import React, {Component} from 'react';
import Contact from './Contact';
import {connect} from 'react-redux';
import Proptypes from 'prop-types';
import {GET_CONTACTS} from '../../actions/types';
import {getContacts} from '../../actions/contactActions';
class Contacts extends Component {
  componentDidMount() {
    this.props.getContacts();
  }

  render() {
    const {contacts} = this.props;
    return (
      <React.Fragment>
        <h1 className="display-4 mb-2">
          <span className="text-danger">Contact</span> List
        </h1>
        {contacts.map((contact) => (
          <Contact key={contact.id} contact={contact} />
        ))}
      </React.Fragment>
    );
  }
}

Contacts.Proptypes = {
  contacts: Proptypes.array.isRequired,
  getContacts: Proptypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  contacts: state.contact.contacts,
});

export default connect(mapStateToProps, {getContacts})(Contacts);



// WEBPACK FOOTER //
// ./src/components/contacts/Contacts.js